import {
  ApiErrorSchema,
  CardsResponseSchema,
  ChatRequestSchema,
  ChatResponseSchema,
  RealtimeSessionRequestSchema,
  RealtimeSessionResponseSchema,
  YouTubeSearchResponseSchema,
  type CardsResponse,
  type ChatRequest,
  type ChatResponse,
  type LocaleCode,
  type RealtimeSessionResponse,
  type YouTubeVideoItem,
} from '../src/shared/contracts';

async function parseApiResponse<T>(response: Response, schema: { parse(data: unknown): T }): Promise<T> {
  const payload = await response.json().catch(() => null);

  if (!response.ok) {
    const error = ApiErrorSchema.safeParse(payload);
    throw new Error(error.success ? error.data.error : `Request failed with status ${response.status}`);
  }

  return schema.parse(payload);
}

export async function fetchCards(lang: LocaleCode): Promise<CardsResponse> {
  const response = await fetch(`/api/cards?lang=${encodeURIComponent(lang)}`);
  return parseApiResponse(response, CardsResponseSchema);
}

export async function sendChat(request: ChatRequest): Promise<ChatResponse> {
  const response = await fetch('/api/chat', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(ChatRequestSchema.parse(request)),
  });

  return parseApiResponse(response, ChatResponseSchema);
}

export async function createRealtimeSession(cardId: string, lang: LocaleCode): Promise<RealtimeSessionResponse> {
  const response = await fetch('/api/realtime/session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(RealtimeSessionRequestSchema.parse({ cardId, lang })),
  });

  return parseApiResponse(response, RealtimeSessionResponseSchema);
}

export async function searchVideos(searchTerms: string): Promise<YouTubeVideoItem[]> {
  const response = await fetch(`/api/youtube-search?q=${encodeURIComponent(searchTerms)}`);
  const payload = await parseApiResponse(response, YouTubeSearchResponseSchema);
  return payload.videos;
}
